<template>
  <img 
    v-lazy="imagePath" 
    :class="['lazy-image', className]" 
    :style="{ height: customHeight || 'auto' }"
    @load="handleImageLoad"
  />
</template>

<script>
export default {
  props: ['imagePath', 'customHeight', 'className'],
  methods: {
    handleImageLoad(e) {
      e.target.classList.add('loaded');
    }
  }
}
</script>

<style>
.lazy-image {
  opacity: 0;
  transition: opacity 1s ease-out;
}

.lazy-image.loaded {
  opacity: 1;
}
</style>